// third-party
import { combineReducers } from "redux";
import { persistReducer } from "redux-persist";
import storage from "redux-persist/lib/storage";

import snackbarReducer from "./slices/snackbar";
import menuReducer from "./slices/menu";
import accountReducer from "./accountReducer";
import projectReducer from "./projectReducer";
import portfolioReducer from "./portfolioReducer";
// ==============================|| COMBINE REDUCER ||============================== //

const reducer = combineReducers({
  auth: persistReducer(
    {
      key: "admin",
      storage,
      keyPrefix: "panel-",
    },
    accountReducer
  ),
  snackbar: snackbarReducer,
  menu: menuReducer,
  project : projectReducer,
  portfolioReducer: portfolioReducer,
});

export default reducer;
